<template>
  <div class="branding-group-layout" :class="{'row': useGridLayout, 'list': !useGridLayout}">
    <BrandingGroupItem :underwriterLogo="underwriter" :useGrid="useGridLayout" v-for="(underwriter, index) in underwriterLogos" :key="index"></BrandingGroupItem>
  </div>
</template>

<script setup>
import BrandingGroupItem from '@/components/common/CorporateBranding/BrandingGroupItem';

// Define component options
defineOptions({
  name: 'BrandingGroupLayoutRow'
});

// Define props
defineProps({
  underwriterLogos: {
    type: Array,
    required: false,
  },
  useGridLayout: {
    type: Boolean,
    required: false,
    default: false,
  },
});
</script>


<style scoped lang="stylus">
.row {
  display: flex;
  flex-flow: row;
  max-width: 100%;
  max-height: 100%;
  height: 72px;
  gap: 32px;
  padding: 16px 0;
  justify-content: space-between;
}

.list {
  flex-flow: column;
}

.branding-group-layout {
  gap: 32px;
}
</style>